import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'market_position_rate_settings',
  inputShow: gql`
    query marketPositionRateSettings($input: MarketRateSettingQueryInput) {
      marketPositionRateSettings(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Rates',
    label: 'Market Position Rate Settings',
    order: 7,
  },
};
